import { compose } from "@reduxjs/toolkit";
import { connect } from "react-redux";

import { getAllLeadSourcesAsync } from "../../../redux/slices/leadSources/leadSources.asyncActions";
import LeadSources from "./LeadSources.layout";

const mapStateToProps = (state) => ({
    language: state.languagesState.languages,
    getSourcesStatus: state.leadAllSourcesState.getAllLeadSources.status,
    sources: state.leadAllSourcesState.getAllLeadSources.leadSources,
});

const mapDispatchToProps = (dispatch) => ({
    dispatchGetLeadSources: () => dispatch(getAllLeadSourcesAsync()),
});

const decorate = compose(connect(mapStateToProps, mapDispatchToProps));

export default decorate(LeadSources);
